export enum ReelReturnErrorFields {
  ClientRma = 'clientRma',
  DepotId = 'depotId',
  ReturnByDate = 'returnByDate',
}
